<div
    class="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-slate-900 dark:border-gray-700 dark:shadow-slate-700/[.7] mb-6 max-w-full">
    <div class="flex flex-row justify-between bg-primary border-b rounded-t-xl py-3 px-4 md:py-4 md:px-5">
        <p class="font-semibold text-md text-white ml-2" *ngIf="model.stato_id !== 'riepilogo'">PAGAMENTI ISTANZA {{
            model.codice }}</p>
        <p class="font-semibold flex items-center text-md text-white ml-2" *ngIf="model.stato_id === 'riepilogo'">
            IMPORTI
            DOVUTI</p>
        <!-- <img src="assets/icons/pagopa.svg" alt="PagoPA" class="h-8 w-auto"
        *ngIf="model.stato_id !== 'pagamento-presentazione'" /> -->
        <div class="flex items-center pl-10" *ngIf="model.stato_id === 'riepilogo'">
            <mat-icon class="icon-size-5 white-icon" matPrefix
                [svgIcon]="'heroicons_solid:question-mark-circle'"></mat-icon>
            <p class="font-semibold text-sm text-white ml-2">DATI DI RIEPILOGO</p>
        </div>
        <div class="flex items-center" *ngIf="model.stato_id === 'pagamento-presentazione'">
            <mat-icon class="text-xl text-white">check_circle</mat-icon>
            <span class="font-semibold text-md text-white ml-2">IN ATTESTA DI PAGAMENTO</span>
        </div>
    </div>

    <!-- Contenuto -->
    @if (pagamenti$ | async; as pagamenti) {
    <div class="p-6">
        @if (pagamenti?.length) {
        @for (pagamento of pagamenti; track pagamento.id) {

        @if(model.stato_id === 'pagamento-presentazione'){
        <div class="flex flex-col bg-white border shadow-sm rounded-xl mt-2 mb-6" *ngIf="!showPanel">
            <div class="flex flex-col py-3 px-4 md:pt-4 md:pb-2 md:px-5">

                <div class="flex flex-row items-center">
                    <mat-icon class="icon-size-8 text-primary" matPrefix
                        [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
                    <div class="text-6xl font-bold ml-3">
                        {{pagamento.stato=='INSERITO'?'Richiesta in attesa di conferma del pagamento':'Richiesta in attesa di pagamento'}}
                    </div>
                </div>

            </div>


            <div class=" flex flex-col items-start sm:px-2.5 md:px-5 md:pb-3 bg-card">

                <div class="text-base">
                    {{pagamento.stato=='INSERITO'?"La tua richiesta è in attesa che il servizio PagoPa riceva la conferma del pagamento da parte dei servizi interbancari, il tempo di attesa può variare da pochi minuti fino anche a 30 minuti":"La tua richiesta è in attesa di pagamento. Puoi pagare immediatamente tramite il pulsante 'Paga Online' oppure generare un avviso di pagamento che potrai pagare successivamente."}}
                </div>

                <div class="flex-col mt-3 text-base">

                    <div class="flex items-center">
                        <span>Causale</span>
                        <span class="font-semibold ml-2">{{ pagamento.causale ? pagamento.causale : '--' }}</span>
                    </div>

                    <div class="flex items-center">
                        <span>Data scadenza:</span>
                        <span class="font-semibold ml-2">{{ pagamento.data_scadenza ? (pagamento.data_scadenza |
                            date:
                            'dd/MM/yyyy') : '---' }}</span>
                    </div>

                    <div class="flex items-center">
                        <span>Importo totale:</span>
                        <span class="font-semibold ml-2">{{pagamento.importo | currency: 'EUR'}}</span>
                    </div>


                </div>

                <div class="flex w-full max-w-screen-xl h-full mt-6">

                    <mat-accordion>
                        <mat-expansion-panel hideToggle>
                            <mat-expansion-panel-header>
                                <mat-panel-title> LEGGI LE ISTRUZIONI </mat-panel-title>
                            </mat-expansion-panel-header>


                            <div class="flex flex-col p-4 my-2 border-s-8 border rounded-md  max-w-full border-primary">

                                <div class="mt-2 text-base text-start justify-center text-secondary">

                                    <p>Avvertenza 1: in caso di pagamento OnLine la risposta non è immediata. Non
                                    effettuare un nuovo pagamento la pratica verrà inviata appena il sistema avrà
                                    ricevuto la conferma del pagamento.</p>

                                    <p>Avvertenza 2: qualora, a seguito dell'invio del pagamento online, tale pagamento non
                                    risulti acquisito nella tabella sottostante nell'arco di 12h, non effettuare un
                                    nuovo pagamento ma inviare una email al servizio  di assistenza, allegando la ricevuta di pagamento
                                    notificata via email da PagoPa.</p>


                                    <p>PER PAGARE CON AVVISO DI PAGAMENTO (BOLLETTINO) CLICCARE SU "Paga con Avviso",
                                    SUCCESSIVAMENTE SARÀ POSSIBILE SCARICARE L'AVVISO DI PAGAMENTO CLICCANDO SU "Scarica
                                    Avviso".</p>


                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                </div>



                <div class="w-full mx-auto bg-white border border-gray-200 shadow rounded-lg overflow-hidden mt-8">
                    <!-- Header con titolo e stato -->
                    <div class="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                        <h2 class="text-2xl font-bold text-gray-800">Dettaglio Importi</h2>
                        <!-- Stato del pagamento, es. "Pagato" -->
                        <span
                            class="px-3 py-1 text-sm font-semibold text-amber-600 border border-amber-600 rounded-full">
                            In attesa di pagamento
                        </span>
                    </div>

                    <!-- Corpo della Card: layout orizzontale per i campi -->
                    <div class="p-6 space-y-4">

                        @for (importo of pagamento.importi; track importo.id; let index = $index){

                        <ng-container
                            *ngTemplateOutlet="dettaglioImporto; context: { importo: importo }"></ng-container>

                        }

                    </div>

                    <!-- Footer con i bottoni -->
                    <div class="px-6 py-4 bg-gray-100 flex justify-end space-x-3 border-t">

                        @if(!pagamento.stato){

                        <button type="button" aria-expanded="false" (click)="pagaAvviso(pagamento.id)"
                            class="italia-it-button  sm:w-[180px] sm:h-[40px] button-spid " aria-expanded="false">
                            <span class="italia-it-button-icon"><mat-icon class="text-white"
                                    svgIcon="heroicons_outline:newspaper"></mat-icon>
                            </span>
                            <span class="flex flex-col md:pt-3 sm:pt-2 sm:text-md">Paga con avviso</span>
                        </button>

<!--                         <button type="button" aria-expanded="false" (click)="pagaOnline(pagamento.id)"
                            class="italia-it-button  sm:w-[180px] sm:h-[40px] button-spid " aria-expanded="false">
                            <span class="italia-it-button-icon"><img
                                    class="md:ml-1.5 lg:ml-3 xl:ml-4 sm:w-[19px] sm:h-[19px] md:w-[29px] md:h-[29px]"
                                    src="assets/icons/pagopa.svg"
                                    onerror="this.src='assets/icons/pagopa.svg'; this.onerror=null;"
                                    alt="logo pagopa" /></span>
                            <span class="flex flex-col md:pt-3 sm:pt-2 sm:text-md">Paga OnLine</span>
                        </button> -->

                        }
                        @else if(pagamento.stato=='INSERITO'){

                        <div class="mt-2 text-base text-secondary">
                            <!-- Messaggio principale con spinner -->
                            <div class="flex items-start gap-4 mb-4">
                                <!-- Loader -->
                                <mat-progress-spinner mode="indeterminate" diameter="20" color="primary"
                                    class="mt-1"></mat-progress-spinner>
                                <!-- Messaggio -->

                                <div class="flex flex-col p-4 my-8 border-s-2 border max-w-full border-primary"
                                    *ngIf="model.stato_id == 'pagamento-presentazione' && !(pagamenti?.length)">
                                    <p class="mb-2 text-start font-semibold text-lg">La pratica è in attesa del
                                        pagamento, dopo che avrai fatto il
                                        pagamento la tua pratica verrà inoltrata automaticamente.</p>

                                    <p class="mb-2 text-start text-md"> <span class="font-semibold text-lg">Avvertenza
                                            1:</span> In caso di pagamento
                                        OnLine la risposta non è immediata (LA MAIL DI CONFERMA DI PAGOPA ARRIVA SEMPRE
                                        PRIMA DELLA VERIFICA FINALE).
                                        Non effettuare un nuovo pagamento la pratica verrà inviata appena il sistema
                                        avrà ricevuto la conferma del
                                        pagamento. NON USARE I COMANDI PAGINA AVANTI INDIETRO, E NON CHIUDERE LA
                                        FINESTRA DEL BROWSER FINO A PAGAMENTO
                                        ULTIMATO</p>


                                    <p class="mb-2 text-start text-md"> <span class="font-semibold text-lg">Avvertenza
                                            2:</span> Qualora, a seguito
                                        dell'invio del pagamento online, tale pagamento non risulti acquisito nella
                                        tabella soprastante nell'arco di
                                        24h, non effettuare un nuovo pagamento ma inviare una email ad
                                        assistenza&#64;istanze-online.it, allegando la
                                        ricevuta di pagamento notificata via email dal servizio PagoPa.</p>
                                </div>

                                <span>
                                    Il tuo pagamento è in attesa di conferma, se hai interrotto il pagamento attenti 15 minuti per un nuovo tentativo.
                                </span>


                            </div>

                            <!-- Secondo messaggio con pulsante Elimina TOLTOOOO -->
                            <div *ngIf="false && eliminaOK(pagamento)" class="flex flex-col gap-2">
                                <!-- Messaggio di interruzione -->
                                <span class="text-amber-600">
                                    Hai interrotto il pagamento? Se non hai ancora effettuato il pagamento, potrai procedere con un nuovo pagamento tra .
                                </span>

                                <!-- Pulsante Elimina -->
                                <div class="flex items-center justify-between">

                                    <!-- Spazio per lo spinner o altri elementi opzionali a sinistra -->
                                    <div class="flex-1"></div>

                                    <!-- Bottone -->
                                    <button type="button" aria-expanded="false" (click)="annullaAvviso(pagamento.id)"
                                        class="italia-it-button  sm:w-[250px] sm:h-[40px] button-spid "
                                        aria-expanded="false">
                                        <span class="italia-it-button-icon"><mat-icon class="text-white"
                                                svgIcon="heroicons_outline:receipt-refund"></mat-icon>
                                        </span>
                                        <span class="flex flex-col md:pt-3 sm:pt-2 sm:text-md">Annulla pagamento</span>
                                    </button>

                                </div>
                            </div>
                        </div>

                        }


                        @else if(pagamento.stato=='AVVISO'){

                        <button type="button" aria-expanded="false" (click)="scaricaAvviso(pagamento)"
                            class="italia-it-button  sm:w-[180px] sm:h-[40px] button-spid " aria-expanded="false">
                            <span class="italia-it-button-icon"><mat-icon class="text-white"
                                    svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                            </span>
                            <span class="flex flex-col md:pt-3 sm:pt-2 sm:text-md">Scarica avviso</span>
                        </button>

                        <button type="button" aria-expanded="false" (click)="annullaAvviso(pagamento.id)"
                            class="italia-it-button  sm:w-[180px] sm:h-[40px] button-spid " aria-expanded="false">
                            <span class="italia-it-button-icon"><mat-icon class="text-white"
                                    svgIcon="heroicons_outline:arrow-uturn-left"></mat-icon>
                            </span>
                            <span class="flex flex-col md:pt-3 sm:pt-2 sm:text-md">Annulla avviso</span>
                        </button>

                        }
                        @else if(pagamento.stato=='NOTIFICATO'){
                        <button type="button" aria-expanded="false" (click)="scaricaRicevutaPagamento(pagamento.id)"
                            class="italia-it-button  sm:w-[250px] sm:h-[40px] button-spid " aria-expanded="false">
                            <span class="italia-it-button-icon"><mat-icon class="text-white"
                                    svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                            </span>
                            <span class="flex flex-col md:pt-3 sm:pt-2 sm:text-md">Ricevuta di pagamento</span>
                        </button>

                        }

                    </div>

                    <div class="flex justify-end px-3 py-2">
                        <button type="button" [routerLink]="['/area-utente']" class="w-auto h-auto bg-primary text-white"
                            mat-flat-button>
                            <span>Chiudi</span>
                        </button>
                    </div>
                </div>


            </div>



            <ng-container *ngIf="model.stato_id === 'presentata' && !(model.numero_protocollo)">
                <div class="flex items-center p-4 md:p-5">
                    <span class="sr-only">Info</span>
                    <!--<h3 class="font-medium ml-3 text-primary">La tua richiesta è stata inoltrata correttamente.</h3>-->
                </div>

                <div class="flex items-center px-4 md:px-5">

                    <div class="mb-0.5 text-primary">
                        L'istanza è in fase di protocollazione.
                        <!--A breve riceverai una email con il numero di protocollo.-->
                    </div>

                </div>

                <div class="flex justify-end px-3 py-2">
                    <button type="button" [routerLink]="['/area-utente']" class="w-auto h-auto bg-primary text-white"
                        mat-flat-button>
                        <span>Chiudi</span>
                    </button>
                </div>

            </ng-container>



            <ng-container *ngIf="model.stato_id === 'errore-protocollo'">
                <div class="flex items-center p-4 md:p-5">
                    <div class="text-red-500">
                        <p class="font-semibold">ERRORE IN FASE DI PROTOCOLLAZIONE</p>
                        <p> Il sistema ha preso in carico la segnalazione di errore</p>
                    </div>
                </div>


                <div class="flex justify-end px-3 py-2">
                    <button type="button" [routerLink]="['/area-utente']" class="w-auto h-auto bg-red-500 text-white"
                        mat-flat-button>
                        <span>Chiudi</span>
                    </button>
                </div>

            </ng-container>

        </div>
        }

        @if (model.stato_id === 'riepilogo'){



        @for (importo of pagamento.importi; track importo.id; let index = $index){

        <ng-container *ngTemplateOutlet="dettaglioImporto; context: { importo: importo }"></ng-container>

        }


        }
        }
        } @else {
        <div class="text-center text-lg text-gray-500 py-6">
            <p>NESSUN IMPORTO DOVUTO ALLA PRESENTAZIONE DELL'ISTANZA</p>
        </div>
        }
    </div>
    }
</div>


<ng-template #dettaglioImporto let-importo="importo">
    <div class="flex flex-col p-6 mt-2.5 rounded border-2 py-2.5 mb-6 bg-card">

        <div class="grid md:grid-cols-3 sm:grid-cols-1 w-full items-center justify-center p-2.5 gap-5">

            <div class="flex flex-col w-full border-b md:col-span-1 sm:col-span-1">
                <mat-label class="font-semibold text-md">Causale</mat-label>
                <p class="mt-1.5 text-secondary font-semibold uppercase">{{
                    importo.causale ? importo.causale
                    : '--' }}</p>
            </div>

            <div class="flex flex-col w-full border-b md:col-span-1 sm:col-span-1">
                <mat-label class="font-semibold text-md">Importo</mat-label>
                <div class="mt-1.5 text-secondary font-semibold uppercase">
                    <span>{{importo.importo | currency: 'EUR'}}</span>
                </div>
            </div>

            <div class="flex flex-col w-full border-b md:col-span-1 sm:col-span-1">
                <mat-label class="font-semibold text-md">Data scadenza</mat-label>
                <div class="mt-1.5 text-secondary font-semibold uppercase flex flex-row justify-between">
                    <span>{{ importo.data_scadenza ? (importo.data_scadenza |
                        date:'dd/MM/yyyy') : '---'
                        }}</span>
                </div>
            </div>


            <span></span>
        </div>
    </div>

</ng-template>
